import {
    GET_REPORT_RULES,
} from '../actions/ReportRuleAction'

const initialState = {
    reports: [],
    reports_pageSize: 20,
    reports_total: 0,
    reports_totalPages: 0,
    reports_item: 0,
    reports_currentPage: 0,
}

const ReportRuleReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_REPORT_RULES: {
            return {
                ...state,
                reports: action.payload.content,
                reports_pageSize: action.payload.size,
                reports_total: action.payload.totalElements,
                reports_totalPages: action.payload.totalPages,
                reports_item: action.payload.numberOfElements,
                reports_currentPage: action.payload.number
            }
        }
        
        default: {
            return state
        }
    }
}

export default ReportRuleReducer
